import { render, staticRenderFns } from "./TableEmptyData.vue?vue&type=template&id=38319aa3&scoped=true&"
import script from "./TableEmptyData.vue?vue&type=script&lang=js&"
export * from "./TableEmptyData.vue?vue&type=script&lang=js&"
import style0 from "./TableEmptyData.vue?vue&type=style&index=0&id=38319aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38319aa3",
  null
  
)

export default component.exports